/**
 * Das Aendern des Erscheinungsbildes -- getrennt von `queries.ts`.
 *
 * Der Grund ist die Buendelgrenze (F4-17): `queries.ts` gehoert zum Portal,
 * diese Datei zur Verwaltung in der Agentenoberflaeche. Der Aufruf zum Lesen
 * ist derselbe und wird geteilt; der zum Schreiben hat im Portalbuendel
 * nichts verloren -- ein Portalnutzer darf ihn ohnehin nicht ausfuehren.
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { request } from '../../lib/apiClient';
import type { PortalSettings } from './api';
import { portalKeys } from './queries';

export function useUpdatePortalBranding() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: Record<string, unknown>) =>
      request<PortalSettings>('/portal/settings', { method: 'PATCH', body: payload }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: portalKeys.settings });
    },
  });
}
